import numerotation from './numerotation'
import reductions from './reductions'

export default {
  numerotation, 
  reductions,
}